import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  viewCarouselWrapper: {
    position: 'absolute',
    display: 'flex',
    gap: '0 16px',
    width: '100vw',
    height: theme.breakpoints.values.md - 160,
  },

  mainContent: {},

  bottomPanel: {
    height: '44px',
    position: 'absolute',
    borderRadius: '10px',
    backgroundColor: theme.palette.grey[50],
    bottom: '100px',
    left: '0',
    right: '0',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    width: '390px',
  },

  closeButton: {
    position: 'absolute',
    right: '16px',
    top: '16px',
  },

  downloadButton: {
    '& svg': {
      marginRight: '8px',
    },
  },

  countInfo: {
    color: theme.palette.grey[600],
    fontWeight: 500,
    minWidth: '60px',
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  panelButton: {
    backgroundColor: theme.palette.grey[50],
    minWidth: '44px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.15s linear',
    textTransform: 'unset',
    color: theme.palette.grey[600],
    fontWeight: 500,
    zIndex: 1,

    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },

    '&.disabled': {
      opacity: 0.5,
    },
  },
}));
